import React from "react";
import { Button,CircularProgress } from "@material-ui/core";
import { inject, observer} from "mobx-react";
import styled, { css } from "styled-components";
import Box from "@material-ui/core/Box";
function SubsheetButtons(props) {
  const count = props.store.noOfRecordsSelected;
  const [isDeleteExecuting, setDeleteExecutionStatus] = React.useState(false);
  const handleUnselect = () => {
    props.store.resetSelectedRecordsCount();
    const gridApi = props.store.gridApi;
    if (gridApi) {
      gridApi.deselectAll();
    }
    let parentDOM = document.getElementById(props.store.gridId);
    let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
    parentDOM.querySelectorAll("input[id='defaultChecked']")[0].checked = false;
    array.map((row) => {
      if (row.checked) {
        row.checked = false;
      }
    });
  };
  const handleDelete = async () => {
    try {
      if (props.store.isSubsheet && props.store.parentListId) {
        const parentListContainerStore =
          window.appStore.getCurrentListContainerStore(
            props.store.parentListId,
          );
        const hasEditPermissions =
          parentListContainerStore?.permissions?.canEdit(
            props.store.parentColumnId,
            props.store.parentRow,
          );
        if (hasEditPermissions && !hasEditPermissions[0]) {
          window.appStore.notificationStore.showNotification(
            "You don't have permission to delete the selected rows",
            "caution",
          );
          return;
        }
      }
      await window.appStore.notificationStore.confirm({
        description: <>This will delete the selected rows</>,
      });
      setDeleteExecutionStatus(true);
      await props.store.bulkDeleteAction();
      setDeleteExecutionStatus(false)
      props.store.resetSelectedRecordsCount();
      props.store.isSubsheetRecordsDeleted = true;
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <StyledOuterDiv className="d-flex">
      <StyledInsideDiv className="textCenter d-flex">
        <StyledInnerDiv>
          {count === 0 ? (
            <Box m={2.8}></Box> // for spacing
          ) : (
            <>
              <StyledButton
                variant="text"
                onClick={handleDelete}
                colorName="red"
              >
                {"Delete(" + count + ")"}
                {isDeleteExecuting && <CircularProgress size={18} color="inherit" />}
              </StyledButton>
              <StyledButton
                variant="text"
                onClick={handleUnselect}
                colorName="black"
              >
                {"Unselect(" + count + ")"}
              </StyledButton>
            </>
          )}
        </StyledInnerDiv>
      </StyledInsideDiv>
    </StyledOuterDiv>
  );
}
const StyledOuterDiv = styled.div`
  width: "100%";
`;

const StyledInsideDiv = styled.div`
  flex: 1;
  marginleft: 20;
  alignitems: center;
`;

const StyledInnerDiv = styled.div`
  display: flex;
`;
const StyledButton = styled(Button)`
  height: 30px !important;
  margin-right: 10px;
  text-transform: uppercase !important;
  margin-bottom: 10px !important;
  margin-top: 5px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  ${(props) =>
    props.colorName == "red" &&
    css`
      color: #f87171 !important;
    `};
`;
export default inject(({ store: appStore }) => ({
  appStore,
}))(observer(SubsheetButtons));
